import Vue from 'vue'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * Update supplies to quotation
 *
 * @param  {object}
 */

const updateSuppliesQuotation = (payload, quotationId) =>
  Vue.$http.put(`purchase/quotation/supplies-prices/${quotationId}/`, payload)
    .then()
    .catch(err => {
      throw err
    })

export default updateSuppliesQuotation


// WEBPACK FOOTER //
// ./src/services/purchase/quotation/updateSuppliesQuotation.js